import styled from "styled-components";

export const ContainerBox = styled.div`
	margin: 0 0;
	padding: 10px;

	.MuiTableCell-root {
		padding: 16px 6px;
	}
`;

export const Title = styled.h6`
	font-weight: bold;
	color: #000;
`;
